import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import Icons from '../components/common/icons'
import { useAuthStore } from '../store/authStore'
import { useLayoutStore } from '../store/layoutStore'
import { sidebarList } from './store'

import './layout.css'
import { Link } from 'react-router-dom'

export default function Sidenav() {
  const { layoutType, expand, setExpand } = useLayoutStore()
  const { userData } = useAuthStore()
  const [sideMenuList, setSideMenuList] = useState(sidebarList)
  const [isExpand, setIsExpand] = useState(false)
  const verifyChildLink = (childItem: any) => {
    return childItem.path === pathname || pathname.includes(childItem.path)
    // childItem?.find((a: any) => a.path === pathname) ? true : false
  }

  useEffect(() => {
    setSideMenuList(sideMenuList)
  }, [userData])
  // const navSubmenu = (index: number, item: any) => {
  //   setActive(!active)
  //       setActiveIndex(index)
  //   // set!expand(!!expand)
  //   navigate(item?.path)
  //   // window.open(item.path, '_self')
  // }
  // // const [sideMenu, setSideMenu] = useState<RouterMenuProps[]>(
  //   generateArray()
  // )
  // const selectedSub = (index: number, item?: any) => {
  //   window.open(item.path, '_self')
  // }

  const { pathname } = useLocation()

  return (
    <div
      className={`bg-white  duration-300  fixed z-20 border-r  ${!expand ? 'sidebar-collapse left-0' : 'sidebar-expand -left-full md:left-0'}`}
    >
      {layoutType === 'sideNav' ? (
        <div
          onClick={() => setExpand(!expand)}
          className=" text-grey-medium size-4 2xl:size-6 hidden md:flex border border-formBorder bg-white rounded-full  items-center justify-center absolute z-20 top-11 2xl:top-14 -right-2 cursor-pointer"
        >
          <Icons
            className={`size-3 2xl:size-4 block transition ${expand ? 'rotate-0' : 'rotate-180'}`}
            name="chevron-left"
          />
        </div>
      ) : (
        ''
      )}
      {/* HEADER  */}
      {/* <div
        className={`flex branch-header fixed z-10  gap-2.5 bg-white duration-300 px-4 py-[14px] md:px-2 lg:px-3 2xl:px-4 md:py-2.5 2xl:py-[14px] border-r border-b ${!expand ? 'sidebar-collapse' : 'sidebar-expand '} `}
      >
        <div className="border 2xl:size-10 size-10 md:size-8 rounded-md 2xl:rounded-xl font-medium text-primary bg-primaryThin shrink-0 flex items-center justify-center text-base">
          <Icons
            name="building-icon"
            className="block md:size-4 2xl:size-5 size-5"
          />
        </div>
        <div
          className={` flex-col flex text-nowrap justify-center overflow-hidden duration-300 `}
        >
          <p className="font-semibold md:leading-3 text-common leading-4  2xl:leading-4 md:text-xxs 2xl:text-common line-clamp-1 text-blackAlt">
            Hiremore
          </p>
          <span className="text-xxs md:text-[10px] 2xl:text-xxs leading-3 md:leading-4  2xl:leading-4 font-normal text-blackAlt">
            Main Branch
          </span>
        </div>
      </div> */}

      {/* MENU LISTS  */}
      <div className=" pt-[68px] md:pt-[52px] 2xl:pt-[68px] overflow-y-auto relative customScroll sidebar-container-height">
        <ul className="py-3 2xl:py-5 mb-[80px] 2xl:mb-[110px] mx-2 lg:mx-2 2xl:mx-4">
          {sideMenuList?.map((item) => (
            <>
              {item.hasAccess && (
                <li key={item.id}>
                  <Link
                    onClick={() => {
                      if (item.name == 'Templates') {
                        setIsExpand(!isExpand)
                      }
                    }}
                    // onClick={() => navSubmenu(index, item)}
                    // transition removed
                    to={item.name == 'Templates' ? '#' : item.path}
                    className={`flex items-center justify-start overflow-hidden p-2 md:p-1.5 2xl:p-2  mb-2 group rounded-sm cursor-pointer gap-2
                    ${item.path == pathname || verifyChildLink(item) ? 'bg-primary ' : 'hover:bg-primaryAlt'} ${!expand ? 'justify-start' : ''} `}
                  >
                    <div
                      className={`2xl:size-6 md:size-5 size-6 shrink-0
                      ${item.path === pathname || verifyChildLink(item) ? 'text-white' : 'text-grey-medium group-hover:text-blackAlt'}`}
                    >
                      <Icons
                        name={item.icon ?? ''}
                        // toolTip={ item.name}
                        toolTip={expand ? '' : item.name}
                      />
                    </div>

                    <span
                      className={`md:text-xxs xl:text-base 2xl:text-base text-base font-medium leading-5 text-nowrap
                    ${item.path === pathname || verifyChildLink(item) ? 'text-white' : 'text-grey-medium group-hover:text-blackAlt'}
                    ${!expand ? 'pointer-events-none sm:w-full 2lg:w-0' : 'pointer-events-auto sm:w-0 2lg:w-full'} `}
                    >
                      {item.name}
                    </span>
                    {item.name == 'Templates' && (
                      <div
                        className={`w-4 h-4 ms-auto transition-all ${isExpand ? '' : '-rotate-90'} ${item.path === pathname ? 'text-white' : ''} ${!expand ? 'hidden ' : ' block'}`}
                      >
                        <Icons name="drop-arrow" />
                      </div>
                    )}
                  </Link>
                  {isExpand && item.name == 'Templates' && (
                    <ul
                      className={` overflow-hidden submenu transition-[max-height] ease-in-out duration-700 `}
                    >
                      <li
                        className={`ps-8 relative before:absolute before:h-[50px] before:w-[8px] before:border before:border-grey-borderAlt before:border-r-0 before:border-t-0 before:-left-[5%] before:-top-[30px]`}
                      >
                        <a href="/job_docs/templates/SMSF Checklist SMSF Updated.docx">
                          <div
                            className={`flex  items-center p-2 transition mb-2 group rounded-sm cursor-pointer hover:text-primary justify-between    `}
                          >
                            <span className={`text-common`}>
                              SMSF Audit Checklist
                            </span>
                          </div>
                        </a>
                      </li>
                      <li
                        className={`ps-8 relative before:absolute before:h-[50px] before:w-[8px] before:border before:border-grey-borderAlt before:border-r-0 before:border-t-0 before:-left-[5%] before:-top-[30px]`}
                      >
                        <a href="/job_docs/templates/Engagement Letter for SMSF Audit.docx 2024 FY (1).docx">
                          <div
                            className={`flex  items-center p-2 transition mb-2 group rounded-sm cursor-pointer hover:text-primary justify-between    `}
                          >
                            <span className={`text-common`}>
                              Engagement Letter
                            </span>
                          </div>
                        </a>
                      </li>
                      <li
                        className={`ps-8 relative before:absolute before:h-[50px] before:w-[8px] before:border before:border-grey-borderAlt before:border-r-0 before:border-t-0 before:-left-[5%] before:-top-[30px]`}
                      >
                        <a href="/job_docs/templates/Trustee Representation Letter to the Auditor - Template 2024 FY.doc">
                          <div
                            className={`flex  items-center p-2 transition mb-2 group rounded-sm cursor-pointer hover:text-primary justify-between    `}
                          >
                            <span className={`text-common`}>
                              Trustee Representation Letter
                            </span>
                          </div>
                        </a>
                      </li>
                      <li
                        className={`ps-8 relative before:absolute before:h-[50px] before:w-[8px] before:border before:border-grey-borderAlt before:border-r-0 before:border-t-0 before:-left-[5%] before:-top-[30px]`}
                      >
                        <a href="/job_docs/templates/ATO _ New Trustee Form.pdf">
                          <div
                            className={`flex  items-center p-2 transition mb-2 group rounded-sm cursor-pointer hover:text-primary justify-between    `}
                          >
                            <span className={`text-common`}>
                              ATO - New Trustee Form
                            </span>
                          </div>
                        </a>
                      </li>
                      <li className="bg-gray-200 py-1.5 ">
                        <div className="ps-3">
                          <span className={`text-base`}>
                            Trustee Declaration
                          </span>
                        </div>
                      </li>
                      <li
                        className={`ps-8 relative before:absolute before:h-[50px] before:w-[8px] before:border before:border-grey-borderAlt before:border-r-0 before:border-t-0 before:-left-[5%] before:-top-[30px]`}
                      >
                        <a href="/job_docs/templates/Trustee Declaration/Template -Trustee Declaration for a residential property held by an SMSF docs.doc.docx">
                          <div
                            className={`flex  items-center p-2 transition mb-2 group rounded-sm cursor-pointer hover:text-primary justify-between    `}
                          >
                            <span className={`text-common`}>
                              For Residential Property
                            </span>
                          </div>
                        </a>
                      </li>
                      <li
                        className={`ps-8 relative before:absolute before:h-[50px] before:w-[8px] before:border before:border-grey-borderAlt before:border-r-0 before:border-t-0 before:-left-[5%] before:-top-[30px]`}
                      >
                        <a href="/job_docs/templates/Trustee Declaration/Template - Trustee Declaration for a Commercial - Business Real property held by an SMSF docs.doc.docx">
                          <div
                            className={`flex  items-center p-2 transition mb-2 group rounded-sm cursor-pointer hover:text-primary justify-between    `}
                          >
                            <span className={`text-common`}>
                              For Commercial/Business Property
                            </span>
                          </div>
                        </a>
                      </li>
                      <li
                        className={`ps-8 relative before:absolute before:h-[50px] before:w-[8px] before:border before:border-grey-borderAlt before:border-r-0 before:border-t-0 before:-left-[5%] before:-top-[30px]`}
                      >
                        <a href="/job_docs/templates/Trustee Declaration/Template _ Trustee Declaration for Cryptocurrency docs.doc.docx">
                          <div
                            className={`flex  items-center p-2 transition mb-2 group rounded-sm cursor-pointer hover:text-primary justify-between    `}
                          >
                            <span className={`text-common`}>
                              For Cryptocurrency Property
                            </span>
                          </div>
                        </a>
                      </li>
                    </ul>
                  )}

                  {/* {item.dropdown && (
                  <ul
                    className={` overflow-hidden submenu transition-[max-height] ease-in-out duration-700 ${!expand ? 'ps-0' : 'ps-5'} ${(active && activeIndex === index) || verifyChildLink(item.dropdown) ? 'max-h-96' : 'max-h-0'}`}
                  >
                    {item.dropdown?.map((childItem, index) => (
                      <>
                        {!expand && childItem.path === pathname ? (
                          <li
                            className={`relative before:absolute before:h-[50px] before:w-[8px] before:border before:border-grey-borderAlt before:border-r-0 before:border-t-0 before:-left-[5%] before:-top-[30px] ${!expand ? 'before:hidden' : ''}`}
                          >
                            <div>
                              <div
                                onClick={() => selectedSub(childItem.id)}
                                className={`flex  items-center p-2 transition mb-2  rounded-sm cursor-pointer hover:bg-primary bg-primary ${!expand ? 'justify-center py-3 font-semibold' : 'justify-between '} `}
                              >
                                <span className="text-common  text-bgWhite">
                                  {!expand
                                    ? childItem.name.slice(0, 2)
                                    : childItem.name}
                                </span>
                              </div>
                              <div className="flex justify-center text-primary mb-3">
                                <Icons name="three_dot_horizontal" />
                              </div>
                            </div>
                          </li>
                        ) : (
                          <>
                            {expand && (
                              <li
                                className={`relative before:absolute before:h-[50px] before:w-[8px] before:border before:border-grey-borderAlt before:border-r-0 before:border-t-0 before:-left-[5%] before:-top-[30px]`}
                              >
                                <div>
                                  <div
                                    onClick={() =>
                                      selectedSub(index, childItem)
                                    }
                                    className={`flex  items-center p-2 transition mb-3 group rounded-sm cursor-pointer hover:bg-primary justify-between   ${childItem.path === pathname ? 'bg-primary' : ''}  `}
                                  >
                                    <span
                                      className={` text-common group-hover:text-white  ${childItem.path === pathname ? 'text-white ' : 'text-primaryText'}`}
                                    >
                                      {childItem.name}
                                    </span>
                                    <span
                                      className={`text-common group-hover:text-white  ${childItem.path === pathname ? 'text-white ' : 'text-primaryText'}`}
                                    >
                                      {childItem.value}
                                    </span>
                                  </div>
                                </div>
                              </li>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </ul>
                )} */}

                  {item.divider && (
                    <div className="mb-2 border-b border-slate-200"></div>
                  )}
                </li>
              )}
            </>
          ))}
        </ul>

        {/* FOOTER  */}

        {/* <div
          className={` w-full  bg-cardWrapperBg text-xxs leading-4 text-center  py-1 ${expand ? 'hidden md:block' : ' block md:hidden'}`}
        >
          Hiremore
        </div> */}
      </div>
    </div>
  )
}
